import React from 'react';

function Contact() {
  return (
    <div>
      <h2>Kontakt</h2>
      <p>Skontaktuj się z nami: <strong></strong></p>
      <p>Tel:</p>
    </div>
  );
}

export default Contact;
